import React from "react";
import { NavLink } from "react-router-dom";
import { useUsername } from "../../hooks/useUsername";
import Avatar from "../Avatar/Avatar";
import BackButton from "../BackButton/BackButton";
import "./UniversalSidebar.css";

// The menu is grouped so the games always come first and never get mixed in
// with the reading pages: people come here to play. The leaderboard sits on
// its own between them, because it is the reason to play again.
const GAMES = [
  { path: "/quiz", icon: "fa-gamepad", label: "Character Quiz" },
  { path: "/image-quiz", icon: "fa-picture-o", label: "Image Quiz" },
  { path: "/devil-fruit-quiz", icon: "fa-apple", label: "Devil Fruit Quiz" },
  { path: "/bounty-battle", icon: "fa-money", label: "Bounty Battle" },
  { path: "/puzzle", icon: "fa-puzzle-piece", label: "Jigsaw Puzzle" },
  { path: "/which-character", icon: "fa-question-circle", label: "Which Character Are You?" },
  { path: "/wanted", icon: "fa-camera", label: "WANTED Poster Maker" },
  { path: "/crew", icon: "fa-flag", label: "Build Your Crew" },
  { path: "/history", icon: "fa-history", label: "Your Games" },
];

const EXPLORE = [
  { path: "/characters", icon: "fa-users", label: "Character Archive" },
  { path: "/fruits", icon: "fa-lemon-o", label: "Devil Fruits" },
  { path: "/bounties", icon: "fa-list-ol", label: "Bounty Rankings" },
  { path: "/compare", icon: "fa-exchange", label: "Compare Characters" },
  { path: "/arcs", icon: "fa-map-o", label: "Story Arcs" },
  { path: "/guides", icon: "fa-book", label: "Guides" },
];

const UniversalSidebar = ({ isOpen, onClose }) => {
  const { hasUsername, isAuthenticated, username, avatar, logout } = useUsername();

  const handleLogout = () => {
    logout();
    onClose();
  };

  const link = (item) => (
    <li key={item.path} className="sidebar-item">
      <NavLink
        to={item.path}
        end={item.path === "/"}
        className={({ isActive }) => (isActive ? "sidebar-link active" : "sidebar-link")}
        onClick={onClose}
      >
        <i className={`fa ${item.icon}`}></i>
        <span>{item.label}</span>
      </NavLink>
    </li>
  );

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}

      <aside className={`universal-sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <nav className="sidebar-nav">
          <BackButton variant="sidebar" />

          <p className="sidebar-section-label">Games</p>
          <ul className="sidebar-menu">
            {link({ path: "/", icon: "fa-home", label: "All Games" })}
            {GAMES.map(link)}
          </ul>

          <div className="sidebar-divider"></div>

          <ul className="sidebar-menu">
            <li className="sidebar-item">
              <NavLink
                to="/leaderboard"
                className={({ isActive }) =>
                  isActive ? "sidebar-link board-link active" : "sidebar-link board-link"
                }
                onClick={onClose}
              >
                <i className="fa fa-trophy"></i>
                <span>Leaderboard</span>
              </NavLink>
            </li>
          </ul>

          <div className="sidebar-divider"></div>

          <p className="sidebar-section-label">Explore</p>
          <ul className="sidebar-menu">{EXPLORE.map(link)}</ul>

          <div className="sidebar-divider"></div>

          <p className="sidebar-section-label">You</p>
          <ul className="sidebar-menu">
            {link({ path: "/profile", icon: "fa-user", label: "Profile" })}

            {/* Login link - shown when not authenticated */}
            {!isAuthenticated && (
              <li className="sidebar-item">
                <NavLink
                  to="/login"
                  className={({ isActive }) =>
                    isActive ? "sidebar-link active login-link" : "sidebar-link login-link"
                  }
                  onClick={onClose}
                >
                  <i className="fa fa-sign-in"></i>
                  <span>Login</span>
                </NavLink>
              </li>
            )}
          </ul>

          {/* User section - shown when authenticated */}
          {isAuthenticated && hasUsername && (
            <>
              <div className="sidebar-divider"></div>
              <div className="sidebar-user-section">
                <div className="user-info">
                  <Avatar value={avatar} className="user-icon" alt="" />
                  <span className="user-name">{username}</span>
                </div>
                <button className="logout-button" onClick={handleLogout}>
                  <i className="fa fa-sign-out"></i>
                  <span>Logout</span>
                </button>
              </div>
            </>
          )}
        </nav>
      </aside>
    </>
  );
};

export default UniversalSidebar;
